export const navigation = {
  montessori: "Montessori",
  openHouse: "Journée Portes Ouvertes",
  contact: "Contact",
  aboutUs: "À Propos",
  prices: "Tarifs",
  school: {
    main: "École",
    aboutUs: "À Propos",
    montessori: "Éducation Montessori",
    trilingual: "Éducation Trilingue"
  },
  schoolLife: {
    main: "Vie Scolaire",
    calendar: "Calendrier Scolaire",
    extracurriculars: "Extrascolaires",
    services: "Services"
  },
  admissions: {
    main: "Admissions",
    process: "Processus d'Admission",
    prices: "Tarifs et Frais",
    visit: "Visitez l'École",
    openHouse: "Journée Portes Ouvertes"
  },
  activities: {
    main: "Activités",
    birthdays: "Anniversaires",
    easterCamp: "Camp de Pâques",
    summerCamp: "Camp d'Été",
    christmasCamp: "Camp de Noël",
    courses: "Cours"
  },
  extracurriculars: "Extrascolaires",
  courses: "Cours",
  camps: {
    main: "Camps",
    easter: "Camp de Pâques",
    summer: "Camp d'Été"
  }
};
